/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/YearAwardsTile',['pixi', 'absolute', 'absolute/stringmanager', 'lodash', 'Solitaire/SolitaireGameMode', 'MenuUI/MenuTile',
        'MenuUI/Label', 'MenuUI/ColorConstants', 'MenuUI/MsftIconButton'],

    function (PIXI, Absolute, _s, _, SolitaireGameMode, MenuTile, Label, ColorConstants, MsftIconButton) {

        var YearAwardsTile = function (config, yearData, year, menu) {
            var defaultConfig = {
                letterStyle: {
                    font: Absolute.ScreenMetrics.getResScale() * 90 + 'px segoe1',
                    tint: 0xffffff,
                    align: 'left'
                }, disableOnClick: false
            };
            this.year = year;
            this.initBackground();
            this.initYearAwardsTile(_.extend(defaultConfig, config), yearData, menu);
            this.initDateInfo(year);
            this.initBadgesInfo();
        };

        YearAwardsTile.prototype = Object.create(MenuTile.prototype);

        YearAwardsTile.prototype.initBackground = function () {
            this.background = PIXI.Sprite.fromFrame('awards/Awards-year-bkg.png');
        };

        YearAwardsTile.prototype.initDateInfo = function (year) {
            var yearLabelText = new PIXI.BitmapText('20' + year, this.config.letterStyle);
            this.yearLabel = new PIXI.Sprite(yearLabelText.generateTexture());
            this.yearLabel.position.x = this.background.width/2 - this.yearLabel.width/2;
            this.yearLabel.position.y = Absolute.Coords.y(40);
            this.background.addChild(this.yearLabel);
        };

        YearAwardsTile.prototype.initBadgesInfo = function () {
            var info = this._getMYearBadgesInfo();
            var config = {
                font: Absolute.ScreenMetrics.getResScale() * 20 + 'px segoe1',
                tint: 0xffffff,
                align: 'center'
            };
            var bronzeText = new PIXI.BitmapText(info.bronzeBadgesWon.toString(), config);
            var bronzeTextSprite = new PIXI.Sprite(bronzeText.generateTexture());
            bronzeTextSprite.position.x = Absolute.Coords.x(44) - bronzeTextSprite.width/2;
            bronzeTextSprite.position.y = Absolute.Coords.y(197);
           
            var silverText = new PIXI.BitmapText(info.silverBadgesWon.toString(), config);
            var silverTextSprite = new PIXI.Sprite(silverText.generateTexture());
            silverTextSprite.position.x = Absolute.Coords.x(105) - silverTextSprite.width/2;
            silverTextSprite.position.y = Absolute.Coords.y(197);
           
            var goldText = new PIXI.BitmapText(info.goldBadgesWon.toString(), config);
            var goldTextSprite = new PIXI.Sprite(goldText.generateTexture());
            goldTextSprite.position.x = Absolute.Coords.x(166) - goldTextSprite.width/2;
            goldTextSprite.position.y = Absolute.Coords.y(197);
           
            var diamondText = new PIXI.BitmapText(info.diamondBadgesWon.toString(), config);
            var diamondTextSprite = new PIXI.Sprite(diamondText.generateTexture());
            diamondTextSprite.position.x = Absolute.Coords.x(227) - diamondTextSprite.width/2;
            diamondTextSprite.position.y = Absolute.Coords.y(197);

            this.background.addChild(bronzeTextSprite);
            this.background.addChild(silverTextSprite);
            this.background.addChild(goldTextSprite);
            this.background.addChild(diamondTextSprite);
        };

        YearAwardsTile.prototype.initYearAwardsTile = function (config, yearData, menu) {
            this.config = config;
            this.menu = menu;
            this.yearData = yearData;
            config.image = this.background;
            MenuTile.call(this, config);
        };

        YearAwardsTile.prototype.handleClick = function () {
            this.menu.handleYearSelect(this.year);
            this.down = false;
        };

        YearAwardsTile.prototype.onShow = function () {
            this.statsModel.updateStats();
            this.showStats();
            this.interactive = this.hasMoreData;
        };

        YearAwardsTile.prototype._getMYearBadgesInfo = function () {
            var ret = {
                bronzeBadgesWon: 0, silverBadgesWon: 0,
                goldBadgesWon: 0, diamondBadgesWon: 0
            };
            for(var month in this.yearData) {
                if(this.yearData.hasOwnProperty(month)) {
                    ret.bronzeBadgesWon += this.yearData[month].bronzeBadgesWon;
                    ret.silverBadgesWon += this.yearData[month].silverBadgesWon;
                    ret.goldBadgesWon += this.yearData[month].goldBadgesWon;
                    ret.diamondBadgesWon += this.yearData[month].diamondBadgesWon;
                }
            }
            return ret;
        };

        return YearAwardsTile;

    });
